//@flow
import Model from '../../Utils/Model/model';

export type QuoteItemObject = {
  id:string,
  name:string,
  price:number,
  regular_price:number,
  quote_id:string,
  qty:number,
  sku:string,
  is_reserved:boolean,
  row_discount:number,
  row_total:number,
  product_type:'giftvoucher'|'simple'|'package'|'virtual',
  params:Object, // check against gift card
};

export type GiftParams = {
  amount:string,
  customer_name:string,
  message:string,
  recipient_email:string,
  recipient_name:string,
  day_to_send:string,
};

export default class QuoteItemModel extends Model<QuoteItemObject> {
  getId():string {
    return this.attributes.id;
  }

  getQuoteId():string {
    return this.attributes.quote_id;
  }

  getName():string {
    return this.attributes.name;
  }

  getPrice():number {
    return this.attributes.regular_price;
  }

  getQty():number {
    return this.attributes.qty;
  }

  getSku():string {
    return this.attributes.sku;
  }

  isReserved():boolean {
    return this.attributes.is_reserved;
  }

  isGiftVoucher():boolean {
    return this.attributes.product_type === 'giftvoucher' || false;
  }

  getParams():GiftParams {
    return this.attributes.params;
  }

  isVirtual():boolean {
    return this.isGiftVoucher() || this.attributes.product_type === 'virtual' || false;
  }
}
